import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import { cn } from '@/utils/helpers'

import { getShortcutKey } from '../utils'

export const ShortcutKey = forwardRef(({ className, keys, ...props }, ref) => {
  const modifiedKeys = keys.map((key) => getShortcutKey(key))
  const ariaLabel = modifiedKeys.map((shortcut) => shortcut.readable).join(' + ')

  return (
    <span
      aria-label={ariaLabel}
      className={cn('inline-flex items-center gap-0.5', className)}
      {...props}
      ref={ref}
    >
      {modifiedKeys.map((shortcut) => (
        <kbd
          key={shortcut.symbol}
          className={cn(
            'inline-block min-w-2.5 text-center align-baseline font-sans text-xs font-medium text-[rgb(156,157,160)] capitalize',

            className,
          )}
          {...props}
          ref={ref}
        >
          {shortcut.symbol}
        </kbd>
      ))}
    </span>
  )
})

ShortcutKey.propTypes = {
  className: PropTypes.string,
  keys: PropTypes.array.isRequired,
}

ShortcutKey.displayName = 'ShortcutKey'
